function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash/fp';
import { jobsConstants, mapConstants } from '../constants';
var defaultMapState = {
    mapDataQuery: {},
    mapDefaultDataQuery: {},
    smartSelections: undefined,
    boundaries: undefined,
    lotArea: undefined,
    isLoadingSmartSelections: false,
    smartSelectionsDeliveryMethod: undefined,
    isZoomToggle: false,
    hasSmartSelectionLoaded: false,
    highRes: {
        currentDate: null,
        layers: {
            data: null,
            isLoading: false,
            error: null
        },
        collections: {
            data: null,
            isLoading: false,
            error: null
        }
    },
    isAutomaticDataAvailable: false,
    loadingRhsButtonIds: []
};
var mapReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultMapState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case mapConstants.SET_MAP_DATA_QUERY:
            return _object_spread_props(_object_spread({}, state), {
                mapDataQuery: action.payload
            });
        case mapConstants.SET_MAP_DEFAULT_DATA_QUERY:
            return _object_spread_props(_object_spread({}, state), {
                mapDefaultDataQuery: action.payload
            });
        case mapConstants.CLEAR_MAP_DATA_QUERY:
            return _object_spread_props(_object_spread({}, state), {
                mapDataQuery: {}
            });
        case mapConstants.GET_PLACE_SMART_SELECTIONS:
            return _object_spread_props(_object_spread({}, state), {
                isLoadingSmartSelections: true,
                smartSelectionsDeliveryMethod: action.payload.deliveryMethod,
                loadingRhsButtonIds: action.payload.buttonId ? _to_consumable_array(state.loadingRhsButtonIds).concat([
                    action.payload.buttonId
                ]) : state.loadingRhsButtonIds
            });
        case mapConstants.GET_PLACE_SMART_SELECTIONS_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                smartSelections: action.payload.smartSelections,
                boundaries: action.payload.boundaries,
                lotArea: action.payload.lotArea,
                isLoadingSmartSelections: false,
                smartSelectionsDeliveryMethod: undefined,
                hasSmartSelectionLoaded: true,
                loadingRhsButtonIds: action.payload.buttonId ? state.loadingRhsButtonIds.filter(function(buttonId) {
                    return buttonId !== action.payload.buttonId;
                }) : state.loadingRhsButtonIds
            });
        case mapConstants.SET_AUTOMATIC_SMART_SELECTIONS_AVAILABILITY:
            return _object_spread_props(_object_spread({}, state), {
                isAutomaticDataAvailable: action.payload.isAutomaticDataAvailable,
                boundaries: action.payload.boundaries,
                lotArea: action.payload.lotArea,
                isLoadingSmartSelections: false
            });
        case jobsConstants.QUOTE_ORDER_SUCCESS:
            {
                var _action_payload_user_order;
                var property = (_action_payload_user_order = action.payload.user_order) === null || _action_payload_user_order === void 0 ? void 0 : _action_payload_user_order.property;
                return _object_spread({}, state, property && {
                    boundaries: property,
                    lotArea: property.area_in_sqm
                });
            }
        case mapConstants.CLEAR_BOUNDARIES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    boundaries: undefined
                });
            }
        case jobsConstants.SET_JOB:
            {
                var _action_payload_user_order1, _action_payload;
                return _object_spread_props(_object_spread({}, state), {
                    boundaries: (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_user_order1 = _action_payload.user_order) === null || _action_payload_user_order1 === void 0 ? void 0 : _action_payload_user_order1.property
                });
            }
        case mapConstants.CLEAR_SMART_SELECTIONS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    smartSelections: undefined,
                    lotArea: undefined
                });
            }
        case mapConstants.SET_ZOOM_TOGGLE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isZoomToggle: action.payload.isZoomToggle
                });
            }
        case mapConstants.SET_LOT_AREA:
            {
                return _object_spread_props(_object_spread({}, state), {
                    lotArea: action.payload.lotArea
                });
            }
        case mapConstants.RESET_ZOOM_TOGGLE_BOUNDARY_VISIBILITY:
            {
                return _object_spread_props(_object_spread({}, state), {
                    isZoomToggle: false
                });
            }
        case mapConstants.RESET_HAS_SMART_SELECTIONS_LOADED:
            {
                return _object_spread_props(_object_spread({}, state), {
                    hasSmartSelectionLoaded: false
                });
            }
        case mapConstants.LOAD_HIGH_RES_COLLECTIONS:
            return _.set('highRes.collections.isLoading', true)(state);
        case mapConstants.LOAD_HIGH_RES_COLLECTIONS_SUCCESS:
            return _.set('highRes.collections', {
                data: action.payload,
                isLoading: false,
                error: null
            })(state);
        case mapConstants.LOAD_HIGH_RES_COLLECTIONS_FAILURE:
            return _.set('highRes.collections', {
                data: null,
                isLoading: false,
                error: action.payload
            })(state);
        case mapConstants.LOAD_HIGH_RES_LAYERS:
            return _.set('highRes.layers.isLoading', true)(state);
        case mapConstants.LOAD_HIGH_RES_LAYERS_SUCCESS:
            return _.set('highRes.layers', {
                data: action.payload,
                isLoading: false,
                error: null
            })(state);
        case mapConstants.SET_HIGH_RES_CURRENT_DATE:
            return _.set('highRes.currentDate', action.payload)(state);
        case mapConstants.LOAD_HIGH_RES_LAYERS_FAILURE:
            return _.set('highRes.layers', {
                data: null,
                isLoading: false,
                error: action.payload
            })(state);
        case mapConstants.NEXT_HIGH_RES_LAYER:
            {
                var _state_highRes = state.highRes, currentDate = _state_highRes.currentDate, layers = _state_highRes.layers;
                var dates = _.keys(layers.data);
                if (!dates) {
                    console.warn('cannot change date');
                    return state;
                }
                var currentIndex = dates.indexOf(currentDate);
                console.assert(currentIndex !== -1, 'currentDate not found in layers');
                if (currentIndex === dates.length - 1) {
                    console.warn('currentDate is already the latest date');
                    return state;
                }
                var nextDate = dates[currentIndex + 1];
                return _.set('highRes.currentDate', nextDate)(state);
            }
        case mapConstants.PREV_HIGH_RES_LAYER:
            {
                var _state_highRes1 = state.highRes, currentDate1 = _state_highRes1.currentDate, layers1 = _state_highRes1.layers;
                var dates1 = _.keys(layers1.data);
                if (!dates1) {
                    console.warn('cannot change date');
                    return state;
                }
                var currentIndex1 = dates1.indexOf(currentDate1);
                console.assert(currentIndex1 !== -1, 'currentDate not found in layers');
                if (currentIndex1 === 0) {
                    console.warn('currentDate is already the earliest date');
                    return state;
                }
                var prevDate = dates1[currentIndex1 - 1];
                return _.set('highRes.currentDate', prevDate)(state);
            }
        case mapConstants.SET_BOUNDARIES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    boundaries: action.payload.boundaries,
                    lotArea: action.payload.lotArea
                });
            }
        default:
            return state;
    }
};
export default mapReducer;
